import { AnyAction } from '@reduxjs/toolkit'
import { Epic } from 'redux-observable'
import { of, from } from 'rxjs'
import { switchMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators'

import {
  fetchSubscriptionDetail,
  fetchSubscriptionDetailSuccess,
  fetchSubscriptionDetailError,
} from './subscriptionDetail.reducer'

import { SubscriptionDetailService } from '../services/subscriptionDetail.service'

import { ServiceError } from '~/common/model'
import { RootState } from '~/core/store/root.reducer'

export const fetchSubscriptionDetailDataEpic: Epic<
  AnyAction,
  AnyAction,
  RootState,
  { subscriptionDetailService: SubscriptionDetailService }
> = (action$, state$, { subscriptionDetailService }) =>
  action$.pipe(
    filter(fetchSubscriptionDetail.match),
    withLatestFrom(state$),
    switchMap(([action]) =>
      from(subscriptionDetailService.fetchSubscriptionDetail(action.payload)).pipe(
        map((result) => fetchSubscriptionDetailSuccess(result)),
        catchError((error: ServiceError) => {
          return of(
            fetchSubscriptionDetailError({
              error: {
                errorMessage: error?.response?.statusText,
                errorCode: error?.response?.status,
                id: '',
              },
              subscriptionId: action.payload.subscriptionId,
            }),
          )
        }),
      ),
    ),
  )

export default {
  fetchSubscriptionDetailDataEpic,
}
